import { FormioCustomComponentInfo, createCustomFormioComponent, registerCustomFormioComponentWithClass } from '@formio/angular';
import { CustomAudioRecorderComponent } from './custom-audio-recorder.component';
import { Injector } from '@angular/core';

export const AudioRecorderInfo: FormioCustomComponentInfo = {
	type: 'audioRecorder',
	selector: 'app-custom-audio-recorder',
	title: 'Grabador de Audio',
	group: 'advanced',
	icon: 'microphone',
	weight: 10,
	changeEvent: 'valueChange',
	fieldOptions: ['label', 'key', 'maxTime']
};

/**
 * Builds a Formio class that skips redraw when the audio recorder's own value
 * hasn't changed. Without this, Formio tears down and rebuilds the inner
 * <app-custom-audio-recorder> element on every change to any other form field,
 * which causes the audio element to flicker / reset.
 */
function buildAudioRecorderFormioClass(): unknown {
	const BaseFormioClass: ReturnType<typeof createCustomFormioComponent> = createCustomFormioComponent(AudioRecorderInfo);

	return class AudioRecorderFormioComponent extends BaseFormioClass {
		private lastDataValue: unknown;
		private lastVisibleState: boolean = false;

		public redraw(): unknown {
			const current: unknown = this.dataValue;
			const currentVisible: boolean = this.visible;
			if (this.lastDataValue === current && this.lastVisibleState === currentVisible && this._customAngularElement)
				return Promise.resolve();
			this.lastDataValue = current;
			this.lastVisibleState = currentVisible;
			return super.redraw();
		}
	};
}

export function registerAudioRecorderComponent(injector: Injector): void {
	if (customElements.get(AudioRecorderInfo.selector))
		return;
	try {
		registerCustomFormioComponentWithClass(
			AudioRecorderInfo,
			CustomAudioRecorderComponent,
			buildAudioRecorderFormioClass(),
			injector
		);
	} catch (error) {
		console.error('Error registering audio recorder component:', error);
	}
}